import { TOKEN_KEY } from "../variable";

let savedLocalStorage = null;
let savedSessionStorage = null;

try {
  const localData = localStorage.getItem(TOKEN_KEY);
  if (localData && localData !== "undefined") {
    savedLocalStorage = JSON.parse(localData);
  }
} catch (error) {
  console.error("Failed to parse localStorage data:", error);
}

try {
  const sessionData = sessionStorage.getItem(TOKEN_KEY);
  if (sessionData && sessionData !== "undefined") {
    savedSessionStorage = JSON.parse(sessionData);
  }
} catch (error) {
  console.error("Failed to parse sessionStorage data:", error);
}

export const SavedUser = savedLocalStorage || savedSessionStorage;
export const TOKEN = SavedUser?.token;